/*!
	FrontLauncher
 	Author: Daniel Kita <t.trax0@gmail.com>
 	Repo: https://github.com/T-TraX/FrontLauncher
*/

//import 'foundation-sites';
import 'jquery-match-height';
import '!script!slick-carousel';
import 'vendor/jquery.countdown/jquery.countdown.min.js';
import '!style!css!slick-carousel/slick/slick.css';
require('!style!css!fancybox/dist/css/jquery.fancybox.css');
const fancybox = require('fancybox')($);


const App = {
	isTouch: function () {
        let isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
        return isTouch;
    },
	startFastClick: function() {
		if ('touchAction' in document.body.style) {
		    document.body.style.touchAction = 'manipulation';
		} else {
		    require.ensure(['fastclick'], (require) => {
		        const FastClick = require('fastclick');

		        window.addEventListener('load', () => {
		            FastClick.attach(document.body);
		        });
		    }, 'fastclick');
		}
	},
	initialize: function(){
	    $('.fancybox').fancybox();
	   // $(document).foundation();
	},
	initMap: function(){
		// vanillaJS
		const findMap = document.getElementsByClassName('gmap');
		const scriptUrl = "http://maps.google.com/maps/api/js";

		const loadMap = function(){
			for (let i = findMap.length - 1; i >= 0; i--) {
				let myMap = findMap[i];

				let center = new google.maps.LatLng(myMap.getAttribute('data-lat'), myMap.getAttribute('data-lon'));
				let zoom  = parseInt(myMap.getAttribute('data-zoom')) || 13;

				let map = new google.maps.Map(myMap, {
					zoom,
					center,
					disableDefaultUI: false,
					draggable: !App.isTouch(),
					scrollwheel: false
				});

				let markerOptions = {
					map: map,
				//	icon: 'assets/img/point.png',
					position: center
				};

				let marker = new google.maps.Marker(markerOptions);
			};
		};
		if (findMap.length) {
			const s = document.createElement( 'script' );
			s.setAttribute( 'src', scriptUrl );
			s.onload=loadMap;
			document.body.appendChild( s );
		}
	},
	boxHeight:function(){
		if(screen.width < 820) {
				$('.box-helpers').find('.box .title').matchHeight({
				byRow:true
				});
			}else{
				
				$('.box-helpers').find('.box .title').matchHeight({
						byRow:false
						});
			}
		
	},
	clock:function(){
$('[data-countdown]').each(function() {
   var $this = $(this), finalDate = $(this).data('countdown');
   $this.countdown(finalDate, function(event) {
    $('#clock').html(event.strftime(''
    	+'<h3>Do biegu pozostało</h3>'
    	+'<p>%D  <br><span>dni</span></p>'
    	+'<p>%H <br> <span>godzin</span></p>'
    	+'<p>%M <br> <span>minut</span></p>'
    	+'<p>%S <br><span> sekund</span></p>'
    	
    	));
   });
 
 })

	},
	navigationRWD:function(){
		$('header .navigation nav').clone().appendTo('.navigation-responsive .container');

		var $controll = null;

		$('.nav-button').click(function(){
			if($controll == null) {
				$('.navigation-responsive').css('left','0');
				$('body').css('overflow','hidden');
				$controll = true;
			}else{
				$('.navigation-responsive').css('left','-260px');
				$('body').css('overflow','inherit');
				$controll = null;
			}
		})
		$('.navigation-responsive .icon').click(function(){
			$('.navigation-responsive').css('left','-260px');
			$('body').css('overflow','inherit');
			$controll = null;
		})
	},
	slider:function(){
		$('.slider').slick({
			arrows:false,
			autoplay:true
		});
	},
	init: function(){
		document.addEventListener('DOMContentLoaded', () => {
			this.startFastClick();  
			this.initialize(); 
			this.boxHeight();
			this.clock(); 
			this.navigationRWD();
			this.slider();
		}, false);

		window.onload = () => {
		};

		window.onresize = () => {
			this.boxHeight();

		};
	}
}

App.init();



/** WEBPACK FOOTER **
 ** ./app.js
 **/